/**
 * A finger held on a message opens its actions, as the desktop kebab does on
 * click (FAME-882). Touch only: a mouse has hover, and the kebab for it.
 */

/** Long enough not to fire on a tap, short enough not to feel like waiting. */
const HOLD_MS = 450

/** A finger this far off its start is scrolling, not holding. */
const MOVE_TOLERANCE_PX = 10

type Point = { pointerType: string; clientX: number; clientY: number }

export function createLongPress(onLongPress: () => void, holdMs = HOLD_MS) {
  let timer: ReturnType<typeof setTimeout> | undefined
  let start: { x: number; y: number } | undefined
  let hasFired = false

  const cancel = () => {
    clearTimeout(timer)
    timer = undefined
  }

  return {
    onPointerDown(event: Point) {
      if (event.pointerType !== "touch") return

      cancel()
      hasFired = false
      start = { x: event.clientX, y: event.clientY }
      timer = setTimeout(() => {
        timer = undefined
        hasFired = true
        onLongPress()
      }, holdMs)
    },
    onPointerMove(event: Point) {
      if (!timer || !start) return

      const moved = Math.hypot(event.clientX - start.x, event.clientY - start.y)
      if (moved > MOVE_TOLERANCE_PX) cancel()
    },
    onPointerUp: cancel,
    onPointerCancel: cancel,
    /** The browser's own long-press menu would open over ours. */
    onContextMenu(event: { preventDefault: () => void }) {
      if (timer || hasFired) event.preventDefault()
    },
    cancel,
  }
}
